import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function APIKeysandConfig() {

    return (
        <div>
            <DHeader>API Keys and Config</DHeader>
       
            <DText>
            Managing your API keys for each Node is key to ensuring smooth error-free execution and portability to different systems.
            </DText>

            <DText>
            Typically, API keys are defined in an environment file (.env or env.json). These should never be committed to git or shared. In Python, the load_dotenv function is typically used to read the API keys from the file.
            </DText>

            <DText>
            In Laeyerz, a KeyManager utility is provided to simplify the management of API keys. Import KeyManager from 'laeyerz/utils'.
            </DText>
            
            <DCode>
                {`from laeyerz.utils.Key_Manager import Key_Manager`}
            </DCode>

            <br />

            <DText>
            Create a Key_Manager object and pass to it, as an argument, the path to the environment variable file. The Key_Manager accepts a .env file or a env.json file.
            </DText>

            <DCode>
                {`#Assumes .env file in the same folder
km = Key_Manager()

#If .env in a different folder
km = Key_Manager(path_to_env_file)

#Environment variables can be .env or env.json file`}
            </DCode>

            <DText>
            You can access the relevant API key using either the .get function along with the name of the API_KEY defined or using the [] operator.
            </DText>

            <DCode>
                {`km.get('OPENAI_API_KEY')
km['OPENAI_API_KEY']`}
            </DCode>

            <br />

            {/* <DText>
            Now that you have got an understanding of how to build a simple workflow, we recommend you checkout this tutorial as well to see you can build a two step LLM workflow in a similar way without using any prebuilt or custom LLM Nodes.
            </DText> */}

           

        </div>
    )
}